import React from "react";

import { get, isEmpty, isNull } from "lodash";
import { createExpense, getExpenseOptionsList } from "../../apis/expense";
import { PAYMENT_TYPE } from "../../constants/EXPENSE";
import store from "../../store";
import { getDay } from "../../utils/date";
// import { assignInByExistence } from "../../utils/lodashExtend";
import Guide from "../../components/Guide";
import { getApprobalListByParam } from "../../utils/approval";
import { restoreComma, transformComma } from "../../utils/validator/comma";
import { SET_CARD_LIST } from "../../store/card/actionTypes";
import { getCurrencyCodes } from "../../apis/code";
import { dateToFormat } from "../../utils/date";


const selctOption = (list) => {
  return (
    <>
      {!isEmpty(list) &&
        list.map(({ currency, code }, idx) => (
          <option key={idx} value={code}>
            {currency}({code})
          </option>
        ))}
    </>
  );
};

const getTask = async (props) => {
  const getTitle = (form) => {
    return "경비 청구 요청";
  };

  const {
    // setForm,
    form,
    mode,
    defaultData,
  } = props;

  const currentCodesData = await getCurrencyCodes();
  const currentCodes = currentCodesData.data.currencyCodes;
  const getCurrencyType = (code) => {
    const currencyCode = currentCodes.find(
      (currency) => currency.code === code
    );

    const list = currencyCode.currency.split(' ');

    if (list.length === 1) {
      return list[0] + ' ( ' + code + ' )';
    } else {
      if (list.length === 2) {
        return list[1] + ' ( ' + code + ' )';
      }
    }

    return '( ' + code + ' )';
  };

  //const currentCodes = [{ code: "KRW" }]
  const employee = store.getState().Profile.employee;
  const optionsList = await getExpenseOptionsList();
  const expenseOptionsList = optionsList.map(d => ({
    label: d.name,
    value: d.idx
  }));

  const fields = [
    // {
    //   title: 'TEST',
    //   type: 'button',
    //   onClick: () => {
    //     defaultForm.useTime = ['2021-05-05']
    //     setInForm('useTime', ['2021-05-05'])
    //     console.log('awlektjaklwetjawekjl')
    //   }
    // },
    // {
    //   title: "정산내역",
    //   key: 'cardPurchase',
    //   component: ({ form }) => {
    //     return (
    //       isEmpty(form.cardPurchase) ? <>-</> : (
    //         <>
    //           <span>{get(form, 'cardPurchase.useStore')}</span>
    //           <span className="ml-4">{transformComma(get(form, 'cardPurchase.useAmt'))}원</span>
    //         </>
    //       )
    //     )
    //   }
    // },
    {
      fullWidth: true,
      isHide: mode !== 'create',
      component: () => {
        return <Guide>
          영수증 첨부 후 내용을 자동입력 할 수 있어요
        </Guide>;
      },
    },
    {
      title: "영수증첨부",
      key: "billFiles",
      type: "dropzone",
      changeDefaultFile: true,
      receiptOcrCallback: ({ data, onChange }) => {

        const payText = get(data, 'paymentInfo.date.text');
        const payYear = get(data, 'paymentInfo.date.formatted.year');
        const payMonth = get(data, 'paymentInfo.date.formatted.month');
        const payDay = get(data, 'paymentInfo.date.formatted.day');
        let pay = (payYear && payMonth && payDay) ? [`${payYear}-${payMonth}-${payDay}`] : null;
        if (!pay && payText) {
          pay = [payText.replace(/년/gi, '-').replace(/월/gi, '-').replace(/일/gi, '')];
        }

        const ocrData = {
          // paymentType: null, // 결제 타입 TODO
          usePlace: get(data, 'storeInfo.name.text'), // 가게이름
          useTime: pay,
          // currency: 'KRW', // 추후 필요할지도?
          useAmt: get(data, 'totalPrice.price.formatted.value') // 결제금액
        };
        onChange(ocrData);
        // each(ocrData, (value, key) => {
        //   if (!isEmpty(value)) {
        //     onChange({ [key]: value})
        //   }
        // })
      }
    },
    {
      title: ' ',
      type: 'button',
      label: '카드내역 불러오기',
      isHide: mode !== 'create',
      className: "full-width ",
      color: 'gray-line',
      onClick: () => {
        store.dispatch({
          type: SET_CARD_LIST,
          payload: {
            isOpen: true
          }
        });
      },
    },
    [
      {
        title: "지불방법",
        type: 'select',
        key: "paymentType",
        required: true,
        options: {
          list: PAYMENT_TYPE
        },
        disabled: !isEmpty(form?.cardPurchase)
      },
      {
        title: "사용일",
        type: 'datepicker',
        key: 'useTime[0]',
        required: true,
      }
    ],
    {
      title: "금액",
      key: "currency",
      type: "select-input",
      required: true,
      options: {
        selectName: "currency",
        inputName: "useAmt",
        //unitLabel: "원",
        inputValue: 'useAmt',
        children: selctOption(currentCodes),
        inputOnChange: (e, onChange) => {
          const { name, value } = e.target;
          onChange({ [name]: transformComma(value) });
        }
      },
      // onKeyUp: (e) => {
      //   e.target.value = transformComma(e.target.value);
      // },

      detail: 'component',
      component: ({ form }) => {
        return <>{transformComma(form.useAmt)} {getCurrencyType(form.currency)}</>;
      }
    },
    {
      title: "비용항목",
      type: 'select',
      key: "expenseOptionIdx",
      required: true,
      options: {
        list: expenseOptionsList
      }
    },
    {
      title: "사용처",
      key: "usePlace",
      type: "input",
      required: true,
    },
    {
      title: "상세내용",
      key: "description",
      type: "input",
    },
    {
      type: "line",
    },
    {
      title: "제목",
      key: "title",
      type: "input",
    },
    {
      title: "사유",
      key: "reason",
      type: "textarea",
    },
  ];


  let defaultPaymentType = PAYMENT_TYPE[0].value;
  if (mode === 'detail') {
    defaultPaymentType = get(defaultData, 'data.expense.expenseItems[0].paymentType', '-');
    const paymentType = PAYMENT_TYPE.find(t => t.value === defaultPaymentType);
    if (paymentType) {
      defaultPaymentType = paymentType.label;
    }
  }

  const defaultForm = {
    cardPurchase: null,
    psnlCardUseIdx: null,
    corpCardUseIdx: null,
    billFiles: get(defaultData, 'data.expense.expenseItems[0].billFiles', []),
    paymentType: defaultPaymentType,
    useTime: [
      dateToFormat(get(defaultData, 'data.expense.expenseItems[0].useTime', getDay())),
    ],
    currency: get(defaultData, 'data.expense.expenseItems[0].currency', 'KRW'),
    useAmt: get(defaultData, 'data.expense.expenseItems[0].useAmt', ''),
    expenseOptionIdx: mode === "create"
      ? get(defaultData, 'data.expense.expenseItems[0].expenseOptionIdx', String(expenseOptionsList[0].value)) + ""
      : get(defaultData, 'data.expense.expenseOptionName'),

    usePlace: get(defaultData, 'data.expense.expenseItems[0].usePlace', ''),
    description: get(defaultData, 'data.expense.expenseItems[0].description', ''),
    title: get(defaultData, 'data.expense.title', getTitle()),
    reason: get(defaultData, 'data.expense.reason', ''),
  };

  const create = (form) => {
    let params = {};
    if (!isEmpty(form.cardPurchase)) {
      params = {
        reqEmployeeIdx: employee.idx,
        title: form.title,
        reason: form.reason,
        items: [
          {
            expenseOptionIdx: form.expenseOptionIdx,
            paymentType: form.paymentType,
            billFiles: form.billFiles,
            currency: form.currency,
            description: form.description,
            ...!isNull(form.corpCardUseIdx) ? { corpCardUseIdx: form.corpCardUseIdx } : {},
            ...!isNull(form.psnlCardUseIdx) ? { psnlCardUseIdx: form.psnlCardUseIdx } : {}
          },
        ],
        approvals: getApprobalListByParam(form.approverEmployees, form.referenceEmployees),
      };
    } else {
      params = {
        reqEmployeeIdx: employee.idx,
        title: form.title,
        reason: form.reason,
        items: [
          {
            expenseOptionIdx: form.expenseOptionIdx,
            paymentType: form.paymentType,
            billFiles: form.billFiles,
            description: form.description,
            currency: form.currency,
            useAmt: restoreComma(form.useAmt),
            usePlace: form.usePlace,
            useTime: form.useTime[0],
          },
        ],
        approvals: getApprobalListByParam(form.approverEmployees, form.referenceEmployees),
      };
    }

    return createExpense(params);
  };

  const validate = (form) => {
    let errors = {};
    if (!form.useAmt) {
      errors['currency'] = '금액은 필수 입니다.';
    }
    if (!form.paymentType) {
      errors['paymentType'] = '지불방법은 필수 입니다.';
    }
    return errors;
  };
  return {
    fields, defaultForm, create, validate
  };
};

export default getTask;